module.exports = "query IssueMessagesInfosQuery{issueDownloadRoute:route(name:\"issue_download\",arguments:\"issue_file_id=None\"){url}}"